module.exports = __webpack_public_path__ + "static/1-a23a6eb4433ab55780772534dc50d631.jpg";